<mat-table
  matSort
  [dataSource]="dataSource"
>
  <ng-container matColumnDef="prefix">
    <mat-header-cell *matHeaderCellDef mat-sort-header="prefix">
      {{ 'ORDER_NUMBER.PREFIX' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let element">{{ element.prefix }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="city">
    <mat-header-cell *matHeaderCellDef mat-sort-header="city">
      {{ 'ORDER_NUMBER.CITY' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let element">{{ element.city }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="type">
    <mat-header-cell *matHeaderCellDef mat-sort-header="type">
      {{ 'ORDER_NUMBER.NUMBER_TYPE' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let element">{{ element.type }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="priceSetup">
    <mat-header-cell *matHeaderCellDef mat-sort-header="priceSetup">
      {{ 'ORDER_NUMBER.ONE_TIME_FEE' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let element">
      <cc-price [price]="element.price" [isFree]="isFree(element)"></cc-price>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="price">
    <mat-header-cell *matHeaderCellDef mat-sort-header="price">
      {{ 'ORDER_NUMBER.MONTHLY_FEE' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let element">
      <cc-price [price]="element.price" [isFree]="isFree(element)"></cc-price>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="requiredDocumentsCodes">
    <mat-header-cell *matHeaderCellDef mat-sort-header="requiredDocumentsCodes">
      {{ 'ORDER_NUMBER.REGISTRATION' | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let element">
      <span translate>{{element.hasRequiredDocuments ? 'YES' : 'NO'}}</span>
      <cc-documents-tooltip-icon
        *ngIf="element.hasRequiredDocuments"
        [documents]="element.requiredDocumentsCodes"
        [fallbackDocumentsTranslations]="allPossibleDocuments$ | async"
      ></cc-documents-tooltip-icon>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="action">
    <mat-header-cell *matHeaderCellDef></mat-header-cell>
    <mat-cell *matCellDef="let element">
      <button
        mat-raised-button
        (click)="getNumber(element)"
        color="primary-full"
        class="pull-right">
        <span translate>{{element.buttonLabel}}</span>
      </button>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
</mat-table>
